import { render, staticRenderFns } from "./BoardWrite.vue?vue&type=template&id=705173ac"
import script from "./BoardWrite.ts?vue&type=script&lang=ts&external"
export * from "./BoardWrite.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardWrite.vue?vue&type=style&index=0&id=705173ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports